export const createURL = (url) =>
  new URL(typeof url === 'string' && !url.includes('http') ? `https://${url}` : url);

export const getSubdomains = (uri) => {
  const url = createURL(uri);
  const subdomains = url.hostname.split('.').slice(0, -2);

  return subdomains;
};
